t = require('views/internal/teacup-with-helpers')('boards_sidebar')

module.exports = t.renderable ->
  t.ul '.sidebar-boards-list.js-board-results'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_sidebar_filtered_boards.coffee